/* eslint-disable react/no-danger,react/no-string-refs,no-nested-ternary */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './message.scss';
import './mobile-message.scss';
import PreviewModal from '@/components/preview_modal/preview_modal';
import { postMessageData, request, ApiUri } from '@/helper';
import MessageItem from '@/components/message/items';
import { getToken } from '@/lib/fetch';
import app, { isTouchScreen } from '@/api/app';

/**
 * 消息组件
 */
export default class Message extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playingMessageId: '',
    };
    this.previewDiv = null;
    this.addModal = this.addModal.bind(this);

    this.messageContainer = React.createRef();
  }

  componentDidMount() {
    // noinspection JSValidateTypes
    /** @type import('@xigua/app-bridge/dist/drivers').FlutterBridge */
    const flutterBridge = app;

    const msContainer = this.messageContainer.current;
    msContainer.addEventListener('click', (e) => {
      e.preventDefault();
      const { tagName } = e.target;

      // 图片查看器
      if (tagName && tagName === 'IMG' && !e.target.getAttribute('data-no-preview')) {
        let { src } = e.target;
        [src] = src.split('?');

        flutterBridge.caniuse('flutter_openPicture').then((canOpenImage) => {
          if (canOpenImage) {
            flutterBridge.openURLExternally(src, { mime: 'image/*' }).then();
            return;
          }
          // 原有逻辑
          this.addModal(src);
        });
        return;
      }

      // 视频查看器
      const videoPreviewURL = e.target.getAttribute('data-video-preview-url');
      if (videoPreviewURL) {
        flutterBridge.caniuse('flutter_openVideo').then((canOpenVideo) => {
          if (canOpenVideo) {
            flutterBridge.openURLExternally(videoPreviewURL, { mime: 'video/*' }).then();
            return;
          }
          // 原有逻辑
          this.addModal(videoPreviewURL, 'video');
        });
        return;
      }

      // 外部链接
      if (tagName && tagName === 'A') {
        const { href } = e.target;
        if (href) {
          flutterBridge.caniuse('openURLExternally').then((canOpen) => {
            if (canOpen) {
              flutterBridge.openURLExternally(href).then();
              return;
            }
            window.open(href);
          });
        }
      }
    });
    // fixme 移入 messageItem 中
    // noinspection JSUnresolvedVariable
    msContainer.addEventListener('click', (e) => {
      const questionNode = e.target;
      if (this._isQuestionNode(questionNode)) {
        this.askQuestion(questionNode);
      }
    });
  }


  // 播放音频
  // noinspection JSUnusedGlobalSymbols
  playRecord = (message) => {
    // eslint-disable-next-line no-console
    console.log(message);
    const isPauseOrPlay = this.state.playingMessageId === message.messageId
      ? 'pause'
      : 'play';
    if (isPauseOrPlay === 'pause') {
      this.refs[message.messageId].load();
      this.setState({
        playingMessageId: '',
      });
    } else if (isPauseOrPlay === 'play') {
      this.refs[this.state.playingMessageId] && this.refs[this.state.playingMessageId].load();
      this.setState({
        playingMessageId: message.messageId,
      }, () => {
        this.refs[message.messageId].play();
        this.refs[message.messageId].addEventListener('ended', () => {
          this.setState({
            playingMessageId: '',
          });
        });
      });
    }
  };

  // 是否是问题元素节点
  _isQuestionNode(node) {
    return node.getAttribute('data-tag');
  }

  /**
   * 打开弹窗
   * @param {string} src 资源链接
   * @param {'img' | 'video'} mediaTag 渲染时使用的 html 标签
   */
  addModal(src, mediaTag = 'img') {
    this.previewDiv = document.createElement('div');
    this.previewDiv.id = 'preview_img_modal';
    document.body.appendChild(this.previewDiv);
    const newStyle = `${document.body.getAttribute('style')}overflow: hidden;`;
    document.body.setAttribute('style', newStyle);
    ReactDOM.render(
      <PreviewModal isMobile={isTouchScreen()} src={src} mediaTag={mediaTag} remove={() => this.removeModal()} />,
      this.previewDiv,
    );
  }

  removeModal() {
    ReactDOM.unmountComponentAtNode(this.previewDiv);
    document.body.removeChild(this.previewDiv);
    const newStyle = document.body.getAttribute('style').replace(/overflow:\shidden;/g, '');
    document.body.setAttribute('style', newStyle);
  }

  // 获取答案
  askQuestion(node) {
    const { data, $updateMessage, methods } = this.props;
    let lectureId = data && data.lectureId;
    lectureId = lectureId || node.getAttribute('data-lectureid');
    const formData = {
      message_text: node.getAttribute('data-text'),
      message_image: `![image](${node.getAttribute('data-image')})`,
      has_ticket: data && data.hasTicket,
      last_message_course_id: '',
      last_message_package_id: '',
      lecture_id: lectureId,
      message_tag: node.getAttribute('data-tag'),
      message_template_item_id: node.getAttribute('data-itemid'),
      message: {
        ...postMessageData(data, {}),
      },
    };
    if (methods.onClickQuestionItem) {
      methods.onClickQuestionItem({ ...node.dataset });
    }
    this.ajaxObtainAnswer(formData).then((res) => {
      res && res.body && res.body.forEach((message) => {
        // noinspection JSValidateTypes
        $updateMessage(message);
      });
    }).catch((e) => {
      // eslint-disable-next-line no-console
      console.error('网络错误：', e);
    });
  }

  // ajax获取答案
  ajaxObtainAnswer(formData) {
    const { data } = this.props;
    return new Promise((resolve, reject) => {
      request({
        url: ApiUri.OBTAIN_ANSWER,
        method: 'post',
        data: formData,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        headers: {
          token: getToken(),
          'x-csrf-token': data && data.csrf,
        },
      }).then((res) => {
        resolve(res);
      }).catch((err, msg) => {
        reject(err, msg);
      });
    });
  }

  render() {
    const { online, messages } = this.props;
    // PC隐藏语音消息
    return (
      <>
        <div className="ms-wrapper">
          <div>
            <div className="ms-container" ref={this.messageContainer}>
              {
                messages
                  ? messages.map((message, index) => (
                    <MessageItem message={message} online={online} key={index} />
                  ))
                  : null
              }
            </div>
          </div>
        </div>
      </>
    );
  }
}

Message.propTypes = {
  data: PropTypes.shape({
    csrf: PropTypes.string,
    hasTicket: PropTypes.any,
    lectureId: PropTypes.string,
  }),
  $updateMessage: PropTypes.func,
  online: PropTypes.bool,
  messages: PropTypes.array,
  methods: PropTypes.object,
};
